// extracted by mini-css-extract-plugin
export var checkboxLabel = "TXM4o";
export var checkmark = "bseuP";
export var inner = "WOCEZ";
export var input = "T822P";
export var outer = "aFzsa";